import React, { useEffect, useState } from "react";

import { ReactComponent as SearchIcon } from "../../assets/icon/ri_search-line.svg";
import { ReactComponent as GiftCardIcon } from "../../assets/icon/ri_gift-line.svg";
import { ReactComponent as ListCardIcon } from "../../assets/icon/ic _list bullets.svg";
import { formatRupiah, useHandleClickLoading } from "../../components/Common/utils";

import Button from "../../components/Common/Button";
const ShorcutPage = () => {
    const isWebSetting = localStorage.getItem('isWebSetting');
    const parseWebSetting = JSON.parse(isWebSetting);
    const isMobileAccessBannner = localStorage.getItem("isMobileAccessBannner");
    const [show, setShow] = useState(true);
    const status = localStorage.getItem("isLogin");
    const handleClickLoading = useHandleClickLoading();

    useEffect(() => {
        setShow(isMobileAccessBannner)
    }, [isMobileAccessBannner]);

    return (!show &&
        <div className="flex flex-row gap-2 p-3 py-2 bg-cardLight  items-center relative -mt-2">
      {status && (  <Button
          initialValue="Periksa Pesanan"
          type="fill"
          color={"#A6A6A6"}
          iconLeft={<SearchIcon className={`w-5  `} />}
          className=" h-[40px] hidden sm:inline-flex rounded-full text-[#A6A6A6]"
          onClick={() => {
            handleClickLoading("/cek-invoice");
          }}
        />)}
        <Button
          initialValue="Daftar Layanan"
          type="fill"
          color={"#A6A6A6"}
          iconLeft={<ListCardIcon className={`w-5  `} />}
          className=" h-[40px] hidden sm:inline-flex rounded-full text-[#A6A6A6]"
          onClick={() => {
            handleClickLoading("/daftar-layanan");
          }}
        />
        {status && (  <Button
          initialValue="Redeem Giftcard"
          type="fill"
          color={"#A6A6A6"}
          iconLeft={<GiftCardIcon className={`w-5  `} />}
          className=" h-[40px] hidden sm:inline-flex rounded-full text-[#A6A6A6]"
          onClick={() => {
            handleClickLoading("/gift-card");
          }}
        />)}
        </div>
    );
}

export default ShorcutPage;